export default {"src":"/_next/static/media/usaToday.5aa91408.svg","height":40,"width":75,"blurWidth":0,"blurHeight":0};